import TopicsMenu from '@klaviyo-mkt/gatsby-components/organisms/topics-menu';

import useAllCategoriesData from '../../hooks/useAllCategoriesData';
import { useTranslation } from 'react-i18next';



const TopicsMenuWithData = ({ selectedTopic, ...props }: { selectedTopic?: string; }) => {
  const { t } = useTranslation();

  const allCategories = useAllCategoriesData();
  /*sortng all categories to disregard case sensitive */
  const sortedCategories = allCategories.sort((a: { name: string; }, b: { name: string; }) => a.name.localeCompare(b.name)).filter((category: { locale: string; }) => category.locale === t('langCodes_localeLowerCase'));
  const featuredResources = {
    name: t('helpCenter_components_topicsMenu_featuredResources_name'),
    slug: '/',
    sourceId: '/',
  };
  
  return (
    <TopicsMenu
      selectedTopic={selectedTopic}
      topics={[
        featuredResources,
        ...sortedCategories,
      ]}
      {...props}
    />
  );
};

export default TopicsMenuWithData;
